import DisplayProducts from "@crescentParts/Components/DisplayProduct";
import MultiSelectDropdown, { Option } from "@crescentParts/Components/MultiSelectDropDown";
import getAHRISystemToolHandlerData from "@crescentParts/Handlers/AHRIHandler/AHRIDataHandler";
import getAHRISystemToolHandlerAttribute from "@crescentParts/Handlers/AHRIHandler/AHRIToolAttribute";
import CustomApplicationState from "@crescentParts/Store/CustomApplicationState";
import AHRISystemToolAhriAttributesHandler from "@crescentParts/Store/Data/AHRISystemData/Handler/AHRIAttribute";
import AHRISystemToolAhriDataHandler from "@crescentParts/Store/Data/AHRISystemData/Handler/FetchProduct";
import { getAHRISystemCurrentPageState } from "@crescentParts/Store/Data/AHRISystemToolPagination/AHRISystemToolPaginationSelector";
import AHRISystemToolPageSizeHandler from "@crescentParts/Store/Data/AHRISystemToolPagination/Handler/AHRISystemToolPageSize";
import AHRISystemPaginationHandler from "@crescentParts/Store/Data/AHRISystemToolPagination/Handler/AHRIToolPagination";
import { AHRISystemToolAttributeModel } from "@crescentParts/Widgets/CustomApiModels";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext } from "@insite/client-framework/Components/IsInShell";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchFieldWrapper, {
    SearchFieldWrapperStyles,
} from "@insite/content-library/Widgets/OrderHistory/SearchFieldWrapper";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import debounce from "lodash/debounce";
import * as React from "react";
import { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css, ThemeProps } from "styled-components";

const mapDispatchToProps = {
    getAHRISystemToolHandlerAttribute,
    getAHRISystemToolHandlerData,
    AHRISystemToolAhriDataHandler,
    AHRISystemPaginationHandler,
    AHRISystemToolAhriAttributesHandler,
    loadRealTimeInventory,
    AHRISystemToolPageSizeHandler,
};

const mapStateToProps = (state: ApplicationState & CustomApplicationState) => {
    const getCurrentPage = getAHRISystemCurrentPageState(state);
    const defaultPageNumber = state?.cpeState?.AHRISystemToolPagination?.ahriSystemToolPageNumber;
    const defaultPageSize = state?.cpeState?.AHRISystemToolPagination?.ahriSystemToolPageSize;
    return {
        getCurrentPage,
        ahriSorting: state.cpeState.AHRISystemData.ahriSorting,
        signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
        currentLocation: getLocation(state),
        isAuthenticated: state.context.session?.isAuthenticated || !state.context.session?.isGuest,
        defaultPageNumber,
        defaultPageSize,
        ahriPagination: state.cpeState.AHRISystemData.ahriPagination,
    };
};

export interface CategoryDropdownStyles {
    dropDownGridItem?: GridItemProps;
}
interface KeyValueModel {
    [key: string]: any;
}

interface Pair {
    displayName: string;
    status: string;
}

interface KeyValuePair {
    attribute: string;
    values: Pair[];
}

interface OwnProps extends WidgetProps {}
type Props = OwnProps &
    ThemeProps<BaseTheme> &
    HasShellContext &
    ResolveThunks<typeof mapDispatchToProps> &
    ReturnType<typeof mapStateToProps> &
    HasHistory;

export const categoryStyles: CategoryDropdownStyles = {
    dropDownGridItem: {
        width: [12, 12, 12, 6, 6],
    },
};

export interface AttributesDropdownStyles {
    attributesContainer?: InjectableCss;
    attributesDropdowns?: InjectableCss;
    attributeValue?: InjectableCss;
    gridContainer?: GridContainerProps;
    gridItem?: GridItemProps;
    searchNotFound?: TypographyPresentationProps;
    searchNotFoundItem?: GridItemProps;
    wrapper?: SearchFieldWrapperStyles;
    seachByAhri?: InjectableCss;
    ahriButtons?: InjectableCss;
    clearAllButton?: ButtonPresentationProps;
    pagination?: PaginationPresentationProps;
}

export const attributeStyles: AttributesDropdownStyles = {
    attributesContainer: {
        css: css`
            margin-top: 28px;
        `,
    },
    attributesDropdowns: {
        css: css`
            border: 1px solid #ccc;
            padding: 10px;
            margin-bottom: 10px;
        `,
    },
    ahriButtons: {
        css: css`
            max-width: 33.33%;
            flex-basis: 33.33%;
            align-items: center;
            > div:first-child {
                margin-top: 30px;
            }
        `,
    },
    clearAllButton: {
        css: css`
            margin-top: 30px;
        `,
    },
    seachByAhri: {
        css: css`
            max-width: 33.33%;
            flex-basis: 33.33%;
            > div:first-child {
                padding: 10px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 100%;
                        flex-basis: 100%;
                    `,
                    css`
                        max-width: 100%;
                        flex-basis: 100%;
                    `,
                    css`
                        max-width: 50%;
                        flex-basis: 50%;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    gridContainer: {
        gap: 28,
        css: css`
            margin: 10px 0px 30px 0px;
        `,
    },
    gridItem: {
        width: [12, 12, 6, 4, 4],
    },
    searchNotFoundItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
            display: flex;
            justify-content: center;
        `,
    },
    searchNotFound: {
        size: 20,
        css: css`
            text-align: center;
        `,
    },
};
const aStyles = attributeStyles;

const AHRISystemTool: React.FC<Props> = ({
    getCurrentPage,
    ahriSorting,
    getAHRISystemToolHandlerData,
    getAHRISystemToolHandlerAttribute,
    AHRISystemToolAhriDataHandler,
    AHRISystemPaginationHandler,
    AHRISystemToolAhriAttributesHandler,
    loadRealTimeInventory,
    history,
    signInUrl,
    isAuthenticated,
    currentLocation,
    defaultPageNumber,
    defaultPageSize,
    ahriPagination,
    AHRISystemToolPageSizeHandler,
    id,
}) => {
    const [attributeDropDownOption, setAttributeDropDownOption] = useState<any[]>([]);
    const [selectedattributes, setSelectedattributes] = useState<any>({});
    const [finalAttributeCollection, setFinalAttributeCollection] = useState<KeyValueModel>({});
    const [loader, setLoader] = useState(false);
    const [inventoryLoader, setInventoryLoader] = useState(false);
    const totalItemCount = ahriPagination?.totalItemCount || null;
    const [currentPage, setCurentPage] = useState<number>(defaultPageNumber);
    const [currentPageSize, setCurentPageSize] = useState<number>(defaultPageSize);
    const [filterLoading, setFilterLoading] = useState(false);

    const capitalizeFirstLetter = (word: string) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
    };
    const [ahriNumber, setAhriNumber] = useState<string>("");

    // ✅ arrangeAttribute now stores actual values
    const arrangeAttribute = (data: AHRISystemToolAttributeModel) => {
        const allAttribute: KeyValuePair[] = [];

        Object.keys(data).forEach(key => {
            const obj: KeyValuePair = {
                attribute: key,
                values: [],
            };

            data[key]?.forEach((attr: any) => {
                const fieldKey = Object.keys(attr)[0];
                const fieldValue = attr[fieldKey];

                obj.attribute = fieldKey;
                obj.values.push({
                    displayName: fieldValue,
                    status: fieldValue,
                });
            });

            allAttribute.push(obj);
        });

        setAttributeDropDownOption(allAttribute);
    };

    const cleanSelectedAttributes = (
        selected: Record<string, string[]>,
        allAttrs: { attribute: string; values: { status: string }[] }[],
    ): Record<string, string[]> => {
        return Object.entries(selected).reduce(
            (acc, [attr, values]) => {
                const foundAttr = allAttrs.find(a => a.attribute === attr);
                if (!foundAttr) return acc;

                const validValues = new Set(foundAttr.values.map(v => v.status));
                const filteredValues = values?.filter(v => validValues.has(v));

                if (filteredValues?.length > 0) {
                    acc[attr] = filteredValues;
                }
                return acc;
            },
            {} as Record<string, string[]>,
        );
    };

    useEffect(() => {
        setSelectedattributes((prev: any) => cleanSelectedAttributes(prev, attributeDropDownOption));
    }, [attributeDropDownOption]);

    useEffect(() => {
        if (!isAuthenticated && signInUrl) {
            const returnUrl = currentLocation.pathname + currentLocation.search;
            if (returnUrl === "/") {
                history.push(`${signInUrl}`);
            } else {
                history.push(`${signInUrl}?returnUrl=${encodeURIComponent(returnUrl)}`);
            }
        } else if (isAuthenticated) {
            const attributesOptions = attributeDropDownOption.reduce<Record<string, Record<string, string>>>(
                (acc, item) => {
                    acc[item.attribute] = item.values.reduce((map: any, v: any) => {
                        map[v.status] = v.displayName;
                        return map;
                    }, {});
                    return acc;
                },
                {},
            );

            const filteredAttributes: Record<string, string> = Object.fromEntries(
                Object.entries(selectedattributes).map(([key, statuses]) => [
                    key,
                    Array.isArray(statuses)
                        ? statuses.map((status: string) => attributesOptions[key]?.[status] ?? status).join(", ")
                        : "",
                ]),
            );
            // Remove "search" or any empty values
            const filteredWithoutSearch = Object.fromEntries(
                Object.entries(filteredAttributes).filter(([key, value]) => key !== "search" && value.trim() !== ""),
            );
            getAHRISystemToolHandlerAttribute({
                filterAttributes: { ...filteredWithoutSearch },
                onSuccess: (result: AHRISystemToolAttributeModel) => {
                    if (result) {
                        arrangeAttribute(result);
                    }
                },
            });
        }
    }, [signInUrl, currentLocation]);

    const handleOptionChange = (option: Option, attribute: KeyValuePair) => {
        setFilterLoading(true);
        const obj = { ...selectedattributes };
        const isSelected = obj[attribute.attribute]?.includes(option.value);

        let values = obj[attribute.attribute] ? [...obj[attribute.attribute]] : [];

        if (isSelected) {
            values = values.filter(val => val !== option.value);
        } else {
            values.push(option.value);
        }

        if (values.length > 0) {
            obj[attribute.attribute] = values;
        } else {
            delete obj[attribute.attribute];
        }

        setSelectedattributes(obj);
        const updatedFinalCollection = {
            ...finalAttributeCollection,
            [attribute.attribute]:
                obj[attribute.attribute]?.map((val: string) => ({
                    label: val,
                    value: val,
                })) || [],
        };
        setFinalAttributeCollection(updatedFinalCollection);

        const attributesOptions = attributeDropDownOption.reduce<Record<string, Record<string, string>>>(
            (acc, item) => {
                acc[item.attribute] = item.values.reduce((map: any, v: any) => {
                    map[v.status] = v.displayName;
                    return map;
                }, {});
                return acc;
            },
            {},
        );

        const filteredAttributes: Record<string, string> = Object.fromEntries(
            Object.entries(obj).map(([key, statuses]) => [
                key,
                Array.isArray(statuses)
                    ? statuses.map((status: string) => attributesOptions[key]?.[status] ?? status).join(", ")
                    : "",
            ]),
        );

        // Remove "search" or any empty values
        const filteredWithoutSearch = Object.fromEntries(
            Object.entries(filteredAttributes).filter(([key, value]) => key !== "search" && value.trim() !== ""),
        );

        getAHRISystemToolHandlerAttribute({
            filterAttributes: { ...filteredWithoutSearch },
            onSuccess: (result: AHRISystemToolAttributeModel) => {
                if (result) {
                    setFilterLoading(false);
                    arrangeAttribute(result);
                }
            },
        });
    };

    useEffect(() => {
        getAHRISystemToolAPI(1, false, ahriSorting);
    }, []);

    useEffect(() => {
        const updatedFinalCollection: KeyValueModel = {};

        Object.keys(selectedattributes).forEach(key => {
            if (Array.isArray(selectedattributes[key])) {
                updatedFinalCollection[key] = selectedattributes[key].map((val: string) => ({
                    label: val,
                    value: val,
                }));
            }
        });

        setFinalAttributeCollection(updatedFinalCollection);
    }, [selectedattributes]);

    const changePage = (newPageIndex: number) => {
        AHRISystemPaginationHandler({
            ahriSystemToolPageNumber: newPageIndex,
        });

        setCurentPage(newPageIndex);

        getAHRISystemToolAPI(newPageIndex, false, ahriSorting);
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = Number(event.currentTarget.value);
        setCurentPageSize(newPageSize);
        AHRISystemToolPageSizeHandler({
            ahriSystemToolPageSize: newPageSize,
        });

        AHRISystemPaginationHandler({
            ahriSystemToolPageNumber: 1,
        });
        setCurentPage(1);
        getAHRISystemToolAPI(1, false, ahriSorting);
    };

    useEffect(() => {
        setCurentPage(defaultPageNumber);
        setCurentPageSize(defaultPageSize);
    }, [defaultPageNumber, ahriPagination, defaultPageSize]);

    const getAHRISystemToolAPI = (pageNo?: number, isClear?: boolean, sortOverride?: string) => {
        AHRISystemToolAhriDataHandler({
            ahriData: null,
            ahriPagination: {},
        });
        const parameter: KeyValueModel = {};
        setLoader(true);
        if (!isClear) {
            Object.keys(finalAttributeCollection).forEach(attribute => {
                const key = attribute.replace(/ /g, "_");
                const data = finalAttributeCollection[attribute].map((attr: any) => attr.label).join(",");
                parameter[key] = data;
            });
        }
        setInventoryLoader(true);
        getAHRISystemToolHandlerData({
            Family: parameter["brand"],
            AC_HeatPump: parameter["aC_HeatPump"] || "",
            Outdoor_Unit_Tonnage: parameter["outdoor_Unit_Tonnage"],
            Family_SEER2: parameter["family_SEER2"],
            Indoor_Type: parameter["indoor_Type"],
            Furnace_BTU: parameter["furnace_BTU"],
            Indoor_Position: parameter["indoor_Position"],
            // C25_Tax_Credit_Qualified: parameter["c25_Tax_Credit_Qualified"] || "",
            page: pageNo || getCurrentPage.ahriSystemToolPageNumber,
            Sort: sortOverride ?? ahriSorting ?? "",
            search: ahriNumber || "",
            refrigerant: parameter["refrigerant"],
            onSuccess: result => {
                if (result) {
                    setLoader(false);
                    const ahriDataModified = JSON.parse(JSON.stringify(result.data));
                    ahriDataModified?.forEach((ahri: any) => {
                        const ahriProduct = ahri?.productId?.split(",") ?? [];
                        ahriProduct.forEach((ahriP: string) => {
                            const id = ahriP.split(":");
                            ahri[id[0]] = {
                                productId: id[1],
                                qtyOnHand: parseInt(id[2], 10),
                            };
                        });
                    });
                    AHRISystemToolAhriDataHandler({
                        ahriData: ahriDataModified,
                        ahriPagination: result.pagination,
                    });
                    setInventoryLoader(false);
                }
            },
        });
    };
    const debounceFun = React.useCallback(
        debounce((value: string) => {
            setSelectedattributes({ ...selectedattributes, search: value });
        }, 500),
        [selectedattributes],
    );

    const handleInputChange = (data: React.ChangeEvent<HTMLInputElement>) => {
        AHRISystemPaginationHandler({
            ahriSystemToolPageNumber: 1,
        });
        setAhriNumber(data.target.value);
        debounceFun(data.target.value);
    };

    const getAHRISystemToolAPIAfterClear = (pageNo?: number, isClear?: boolean) => {
        AHRISystemToolAhriDataHandler({
            ahriData: null,
            ahriPagination: {},
        });
        const parameter: KeyValueModel = {};
        setLoader(true);
        if (!isClear) {
            Object.keys(finalAttributeCollection).forEach(attribute => {
                const key = attribute.replace(/ /g, "_");
                const data = finalAttributeCollection[attribute].map((attr: any) => attr.label).join(",");
                parameter[key] = data;
            });
        }
        setInventoryLoader(true);
        getAHRISystemToolHandlerData({
            Family: parameter["brand"],
            AC_HeatPump: parameter["aC_HeatPump"] || "",
            Outdoor_Unit_Tonnage: parameter["outdoor_Unit_Tonnage"],
            Family_SEER2: parameter["family_SEER2"],
            Indoor_Type: parameter["indoor_Type"],
            Furnace_BTU: parameter["furnace_BTU"],
            Indoor_Position: parameter["indoor_Position"],
            // C25_Tax_Credit_Qualified: parameter["c25_Tax_Credit_Qualified"] || "",
            page: pageNo || getCurrentPage.ahriSystemToolPageNumber,
            Sort: "",
            search: "",
            refrigerant: parameter["refrigerant"],
            onSuccess: result => {
                if (result) {
                    setLoader(false);
                    const ahriDataModified = JSON.parse(JSON.stringify(result.data));
                    ahriDataModified?.forEach((ahri: any) => {
                        const ahriProduct = ahri?.productId?.split(",") ?? [];
                        ahriProduct.forEach((ahriP: string) => {
                            const id = ahriP.split(":");
                            ahri[id[0]] = {
                                productId: id[1],
                                qtyOnHand: parseInt(id[2], 10),
                            };
                        });
                    });
                    AHRISystemToolAhriDataHandler({
                        ahriData: ahriDataModified,
                        ahriPagination: result.pagination,
                    });
                    setInventoryLoader(false);
                }
            },
        });
    };
    const clearAllFilters = () => {
        setAhriNumber("");
        setSelectedattributes({});
        setFinalAttributeCollection({});
        AHRISystemPaginationHandler({
            ahriSystemToolPageNumber: 1,
        });
        getAHRISystemToolAPIAfterClear(1, true);
        getAHRISystemToolHandlerAttribute({
            filterAttributes: {},
            onSuccess: (result: AHRISystemToolAttributeModel) => {
                if (result) {
                    arrangeAttribute(result);
                }
            },
        });
    };

    const submitAllFilters = () => {
        AHRISystemPaginationHandler({
            ahriSystemToolPageNumber: 1,
        });
        getAHRISystemToolAPI(1, false, ahriSorting);
    };

    if (!isAuthenticated) {
        return null;
    }

    return (
        <StyledWrapper>
            <StyledWrapper data-test-selector="categoriesContainer">
                <StyledWrapper {...aStyles.attributesContainer} data-test-selector="attributesContainer">
                    <StyledWrapper {...aStyles.attributesDropdowns} data-test-selector="attributesDropdowns">
                        <LoadingOverlay
                            loading={inventoryLoader || filterLoading}
                            css={css`
                                width: 100%;
                            `}
                        >
                            <GridContainer {...aStyles.gridContainer}>
                                {attributeDropDownOption.map((attribute, i) => {
                                    const options = attribute.values || [];
                                    if (options.length === 0) {
                                        return null;
                                    }
                                    const uniqueOptions = new Map<string, string[]>();
                                    for (const option of options) {
                                        const values = uniqueOptions.get(option.displayName) || [];
                                        values.push(option.status);
                                        uniqueOptions.set(option.displayName, values);
                                    }

                                    const dropDownOptions: any[] = Array.from(uniqueOptions, ([name]) => ({
                                        value: name,
                                        label: name,
                                    }));

                                    return (
                                        <GridItem key={i} {...aStyles.gridItem}>
                                            <SearchFieldWrapper
                                                extendedStyles={aStyles.wrapper}
                                                key={`SearchFieldWrapper-${i}`}
                                            >
                                                <MultiSelectDropdown
                                                    key={`MultiSelectDropdown-${i}`}
                                                    label={capitalizeFirstLetter(attribute.attribute)
                                                        .split("_")
                                                        .join(" ")}
                                                    handleOptionClick={option => handleOptionChange(option, attribute)}
                                                    options={dropDownOptions}
                                                    selectedOptions={
                                                        finalAttributeCollection[attribute.attribute] || []
                                                    }
                                                />
                                            </SearchFieldWrapper>
                                        </GridItem>
                                    );
                                })}

                                {attributeDropDownOption.length > 0 && (
                                    <>
                                        <GridItem {...aStyles.seachByAhri}>
                                            <TextField
                                                value={ahriNumber}
                                                clickableText={translate("Search")}
                                                label={translate("AHRI No")}
                                                onChange={handleInputChange}
                                                data-test-selector="searchByAhriNumber"
                                                placeholder={translate("Search by AHRI")}
                                                autoComplete="off"
                                            />
                                        </GridItem>
                                        <GridItem {...aStyles.ahriButtons}>
                                            <Button
                                                {...aStyles.clearAllButton}
                                                onClick={clearAllFilters}
                                                data-test-selector="ahri_system_clear_filter"
                                            >
                                                {translate("Clear All")}
                                            </Button>
                                        </GridItem>
                                        <GridItem {...aStyles.ahriButtons}>
                                            <Button
                                                {...aStyles.clearAllButton}
                                                onClick={submitAllFilters}
                                                data-test-selector="ahri_system_submit_filter"
                                            >
                                                {translate("Submit")}
                                            </Button>
                                        </GridItem>
                                    </>
                                )}
                            </GridContainer>
                        </LoadingOverlay>
                        <DisplayProducts
                            loader={loader}
                            inventoryLoader={inventoryLoader}
                            setLoader={setLoader}
                            id={id}
                            onSortChange={sort => {
                                AHRISystemPaginationHandler({
                                    ahriSystemToolPageNumber: 1,
                                });

                                setCurentPage(1);

                                getAHRISystemToolAPI(1, false, sort);
                            }}
                        />
                        {ahriPagination && totalItemCount !== 0 ? (
                            <Pagination
                                {...aStyles.pagination}
                                resultsCount={totalItemCount as number}
                                currentPage={currentPage}
                                resultsPerPage={currentPageSize}
                                resultsPerPageOptions={[]}
                                onChangePage={changePage}
                                onChangeResultsPerPage={changeResultsPerPage}
                                pageSizeCookie="AHRIToolPage-PageSize"
                            />
                        ) : null}
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const definition: WidgetDefinition = {
    group: "Basic",
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(AHRISystemTool)),
    definition,
};

export default widgetModule;
